import React, { Component, Fragment } from "react";

import * as i18n from "util/i18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import Image from "pages/_components/Image";
import { bool, number, shape } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";

class Movement extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        accountCurrency: number.isRequired,
        movement: shape({}).isRequired,
        showBalance: bool.isRequired,
    };

    render() {
        const { accountCurrency, isDesktop, movement, showBalance } = this.props;
        const { balance, receipt, credit, date, debit, reference } = movement;
        return isDesktop ? (
            <>
                <GridTable.Data columnStart={1} rowStart={1} alignX="flex-start">
                    <CustomText text={date} textType="TEXT" keepSpaceIfNoText />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} alignX="center">
                    <CustomText text={receipt !== 0 && receipt} textType="TEXT" keepSpaceIfNoText />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3} alignX="center">
                    <CustomText
                        text={reference || i18n.get("account.movements.detail.empty", "VARIOS")}
                        textType="TEXT"
                        keepSpaceIfNoText
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 4 : 2} rowStart={isDesktop ? 1 : 2} alignX="center">
                    <FormattedAmount
                        className={`data-amount data-numeric data-amount-${credit ? "credit" : "debit"}`}
                        currency={accountCurrency}
                        quantity={credit || debit}
                    />
                </GridTable.Data>
                {showBalance && (
                    <GridTable.Data columnStart={isDesktop ? 5 : 2} rowStart={isDesktop ? 1 : 3} alignX="center">
                        <FormattedAmount
                            className="data-amount data-numeric"
                            currency={accountCurrency}
                            quantity={balance}
                        />
                    </GridTable.Data>
                )}
                <GridTable.Data
                    columnStart={isDesktop ? 6 : 2}
                    rowStart={1}
                    alignX={isDesktop ? "center" : "right"}
                    className="table-data-icon icon-note">
                    {movement.note && <Image src="images/note.svg" className="svg-icon" />}
                </GridTable.Data>
            </>
        ) : (
            <>
                <GridTable.Data columnStart={1} rowStart={1} alignX="left" className="ellipsis">
                    <span className="data-date">
                        <CustomText text={date} textType="TEXT" keepSpaceIfNoText />
                    </span>
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={2} alignX="left">
                    <CustomText
                        text={reference || i18n.get("account.movements.detail.empty", "VARIOS")}
                        keepSpaceIfNoText
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={1} rowWidth={2} alignX="right" alignY="center">
                    <FormattedAmount
                        className={`data-amount data-numeric data-amount-${credit ? "credit" : "debit"}`}
                        currency={accountCurrency}
                        quantity={credit || Math.abs(debit)}
                    />
                </GridTable.Data>
            </>
        );
    }
}

export default Movement;
